import QueryKeys from '@/utils/QueryKeys';
import { UseQueryOptions } from '@tanstack/react-query';
import useApi from './useApi';

export default function useThemeCss({ ...queryOptions }: Omit<UseQueryOptions<string>, 'queryFn' | 'queryKey'>) {
  return useApi<string>({
    endpoint: '/stylesheets/student_text_combined_style_sheet.css',
    queryKey: [QueryKeys.ThemeCss],
    ...queryOptions,
  });
}
